import {repairPriorityLabels} from '../ui/work-queue-navigation';
import type {ReactNode} from 'react';
import {staffStatus,type WorkActionProjection} from '@myfm/domain';
import {StatusBadge} from '../ui/StatusBadge';
import {formatDateOnly,formatDateTime} from '../dates';

type Facts={report_source?:string;reported_at?:string;reported_by_name?:string;location_description?:string;work_number:string;title:string;development_name:string;property_name?:string;asset_name?:string;work_type:string;lifecycle_status:string;priority:string;responsibility_status?:string|null;assignee_name?:string;target_completion_date?:string};
export function WorkRecordFacts({row,actions,readOnly=false,projection}:{row:Facts;actions?:ReactNode;readOnly?:boolean;projection?:WorkActionProjection|null}){
 const next=projection?[...projection.availableActions,...projection.blockedActions].find(action=>action.id===projection.primaryActionId):undefined;
 const blocker=next?.prerequisites.map(item=>item.message).join(' ');
 const priority=`${repairPriorityLabels[row.priority]??row.priority} priority`;
 return <header className="work-record-header work-record-facts">
<div>
<h1>{row.title}</h1>
<small>{row.work_number} · {row.development_name}{row.property_name?` · ${row.property_name}`:''}</small>
<div className="work-record-meta">
<StatusBadge text={staffStatus(row.lifecycle_status).label}/>
<span>{priority}</span>{row.responsibility_status&&<span className="badge warning">{row.responsibility_status}</span>}{readOnly&&<span>View only</span>}</div>
<dl>{projection&&<div className="mission-next-action">
<dt>Next action</dt>
<dd>{next?.label??(projection.dependencyState==='unavailable'?'Refresh action checks':'No next action is recorded')}</dd>
</div>}{blocker&&<div className="mission-blocker">
<dt>Blocking this action</dt>
<dd>{blocker}</dd>
</div>}<div>
<dt>Work type</dt>
<dd>{row.work_type||'Not recorded'}</dd>
</div>
<div>
<dt>Owner</dt>
<dd>{row.assignee_name||'Unassigned'}</dd>
</div>
<div>
<dt>Target completion</dt>
<dd>{row.target_completion_date?<time dateTime={row.target_completion_date.slice(0,10)}>{formatDateOnly(row.target_completion_date)}</time>:'No target date'}</dd>
</div>{row.reported_at&&<div>
<dt>Reported at</dt>
<dd>{formatDateTime(row.reported_at)}</dd>
</div>}{row.location_description&&<div>
<dt>Location</dt>
<dd>{row.location_description}</dd>
</div>}</dl>{Boolean(row.report_source||row.reported_by_name||row.asset_name)&&<details className="work-reporting-provenance"><summary>Reporting source and additional location</summary><dl>{row.report_source&&<div>
<dt>Reported from</dt>
<dd>{row.report_source}</dd>
</div>}{row.reported_by_name&&<div>
<dt>Reporter</dt>
<dd>{row.reported_by_name}</dd>
</div>}{row.asset_name&&<div>
<dt>Asset</dt>
<dd>{row.asset_name}</dd>
</div>}</dl></details>}
</div>{actions&&<div className="work-header-actions">{actions}</div>}</header>;
}

type Visit={id:string;visit_type:string;outcome?:string;occurred_at?:string;scheduled_at?:string};
export function WorkVisitHistory({visits}:{visits:Visit[]}){
 return <section className="work-visit-history" aria-label="Recorded visits and updates">
<h2>Recorded visits and updates</h2>{visits.length?<ol>{[...visits].reverse().map(visit=>
<li key={visit.id}>
<strong>{visit.visit_type}</strong>
<p>{visit.outcome||'No outcome recorded'}</p>
<small>{visit.occurred_at?<>Occurred <time dateTime={visit.occurred_at}>{formatDateTime(visit.occurred_at)}</time>
</>:visit.scheduled_at?<>Scheduled <time dateTime={visit.scheduled_at}>{formatDateTime(visit.scheduled_at)}</time> · Attendance not recorded</>:'Visit date not recorded'}</small>
</li>)}</ol>:<p>No visits or progress updates are recorded here.</p>}</section>;
}
